import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { DATEFORMAT_FULL, DATEFORMAT_SHORT } from '@/defs/date'
import { type RecType } from '@/defs/rec'
import { useCardsRec } from '@/hooks/useCardsRec'
import { recentDate } from '@/utils/commonUtil'
import { formatDate } from '@/utils/formatUtil'
import { getRecName } from '@/utils/recUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  isInView?: boolean
  rec: RecType
}

export const StatRecReleaseDate = ({ isInView = true, rec }: Props) => {
  const { card, cardPartner, loading } = useCardsRec({ enabled: isInView, rec })
  const fullName = getRecName(rec)

  const date = recentDate(card?.releasedAt, cardPartner?.releasedAt)

  const tooltip = date && (
    <>
      <h2>
        <IconWithLabel iconBefore='calendar'>Release Date</IconWithLabel>
      </h2>
      <p>
        <strong>Release date</strong> is the date the first printing of a card was first legal to play in decks.{' '}
        <strong>{fullName}</strong> was released on <strong>{formatDate(date, DATEFORMAT_FULL)}</strong>.
      </p>
    </>
  )

  return (
    <StatCommonBox isBlank={!isInView} isInView={isInView} label='Released' loading={loading} popover={tooltip}>
      {date && <StatCommonFigure size='sm'>{formatDate(date, DATEFORMAT_SHORT)}</StatCommonFigure>}
    </StatCommonBox>
  )
}
